import React from "react";
import { FaFileAlt } from "react-icons/fa";
import "./SopHeroSection.css";

const SopHeroSection = () => {
  return (
    <section className="_sHSect_v1A_">
      <div className="_sHCont_w2B_">
        <div className="_hIWrap_x3C_">
          <FaFileAlt className="_hIcon_y4D_" />
        </div>
        <h1 className="_hTitle_z5E_">Vanidya Platform SOP</h1>
        <p className="_hSubtitle_a6F_">
          The guiding rules for how we handle disputes, orders, data, and
          partner support—designed for transparency and trust at every step.
        </p>
      </div>
    </section>
  );
};

export default SopHeroSection;
